import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryMapper from "../../documentTypes/service/DocumentTypeIndexCategoryMapper";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";
import Constants from "../common/Constants";

export default class GetCaseDecisionTypeIndexDataInteractor {
  private resource: GetAllResourceEntriesInteractor<IDocumentTypeIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseDecisionId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.caseDecisionTypesPath}/${caseDecisionId}/index-categories`,
      DocumentTypeIndexCategoryMapper,
      DocumentTypeIndexCategoryParamMapper,
      {
        params: { organisationId }
      }
    );
  }
}
